module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph---non-verse-fmepi"
  }, [_vm._v("Death is not an individual but a social event. When, with a barely noticeable sigh, the last gasp of air is exhaled, the blood stops pulsating through arteries and veins, and neurons cease activating the brain, the life of a human organism has ended. Death is not official, however, until the community takes notice.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps_1"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—STEFAN TIMMERMANS")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Postmortem: How Medical Examiners Explain Suspicious Deaths")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph---non-verse-fmepi"
  }, [_vm._v("Every man’s life ends the same way. It is only the details of how he lived and how he died that distinguish one man from another.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—ERNEST HEMINGWAY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0